const CONTACT_IDENTIFIER_KEYS = [
  'identificador_del_contacto',
  'identificador_contacto',
  'identificador_del_contanto',
  'contact_identifier',
  'contact_id',
];

const normalizeIdentifier = value => {
  if (value === null || value === undefined) {
    return '';
  }

  const parsedValue = String(value).trim();
  return parsedValue;
};

const getIdentifierFromRecord = record => {
  if (!record || typeof record !== 'object') {
    return '';
  }

  for (const key of CONTACT_IDENTIFIER_KEYS) {
    const identifier = normalizeIdentifier(record[key]);
    if (identifier) {
      return identifier;
    }
  }

  const inferredKey = Object.keys(record).find(key => {
    const normalizedKey = key.toLowerCase();
    return (
      normalizedKey.includes('identificador') &&
      (normalizedKey.includes('contact') || normalizedKey.includes('contanto'))
    );
  });

  if (!inferredKey) {
    return '';
  }

  return normalizeIdentifier(record[inferredKey]);
};

export const getContactIdentifier = contact => {
  const customIdentifier = getIdentifierFromRecord(contact?.custom_attributes);
  if (customIdentifier) {
    return customIdentifier;
  }

  return getIdentifierFromRecord(contact?.additional_attributes);
};

export const getContactDisplayName = contact => {
  const name = normalizeIdentifier(contact?.name);
  const identifier = getContactIdentifier(contact);

  if (name && identifier) {
    return `${name} (${identifier})`;
  }

  return name || identifier;
};
